<template>
  <div class="year-dropdown" v-show="elementActive">
    <div class="col-3 field-label">{{label}}</div>
    <div class="col-7 field-response">
      <select v-model="currentValue" class="form-select inner-select" :disabled="elementDisabled">
        <option :value="null" v-show="currentValueDefined">Please Select</option>
        <option :value="undefined" v-show="!currentValueDefined">Please Select</option>
        <option v-for="year in years" :value="year" :key="year">{{year}}</option>
      </select>
    </div>
    <div class="col-2 field-error">
      {{errors}}
    </div>
  </div>
</template>

<script>
import PropsMixin from './FormElementPropsMixin'
import ComputedMixin from './FormElementComputedMixin'
import ProgramSpecificMixin from './ProgramSpecificMixin'

export default {
  name: 'YearDropDown',
  mixins: [PropsMixin, ComputedMixin, ProgramSpecificMixin],
  data () {
    var years = []
    var currentYear = (new Date()).getFullYear()
    for (let k = currentYear + 10; k >= 1900; k--) {
      years.push(k)
    }
    return {
      years
    }
  }
}
</script>
